export default {
  avatar: 'Avatar',

  title: 'My Profile',

  namePH: 'Name',
  nameTaken: 'This name is already taken',
  nameErr: 'Your name may only contain letters and numbers',

  emailPH: 'Email',
  emailTaken: 'This email is already taken',
  emailErr: 'This email is invalid',

  oldPwd: 'Current password',
  newPwd: 'New password',
  pwdFail: 'The current password you entered is wrong',

  defmedia: {
    label: 'Content representation',
    text: 'Text',
    simple: 'Simple Language',
    video: 'Video',
    audio: 'Audio'
  },

  submit: 'Save',
  busy: 'Please Wait',
  submitOk: 'Your profile has been successfully updated',
  submitFail: '[PH]'
}



// WEBPACK FOOTER //
// ./src/i18n/profile/en.js